module.exports = __webpack_public_path__ + "static/media/img2.931e309d.jpg";